<template>
  <div v-if="showBanner" class="b-miles-n-bonus-banner">
    <div class="row">
      <!-- col -->
      <div class="col-12 col-lg-1 d-flex align-items-center">
        <div class="e-new" style="margin-right: 20px"><NewLottie /></div>
        <LazyImage
          v-if="milesNBonusLogo"
          :image="milesNBonusLogo"
          class="d-block d-lg-none b-miles-n-bonus-banner__logo" />
      </div>
      <!-- col -->
      <div class="col-12 col-lg-7 b-miles-n-bonus-banner__cont">
        <LazyImage
          v-if="milesNBonusLogo"
          :image="milesNBonusLogo"
          class="d-lg-block d-none b-miles-n-bonus-banner__logo" />
        <span
          class="b-miles-n-bonus-banner__description"
          v-html="dictionary.milesNBonusPromoText"></span>
      </div>
      <!-- col -->
      <div class="col-12 col-lg-3 offset-lg-1 d-flex align-items-center">
        <button
          class="btn btn-primary btn-full-width"
          type="button"
          @click="logIn">
          {{ dictionary.milesNBonusPromoButtonLabel }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import * as lib from '../../lib/lib'
import LazyImage from './common/LazyImage.vue'
import NewLottie from './../components/lotties/New.vue'

export default {
  components: {
    LazyImage,
    NewLottie,
  },
  data() {
    return {
      dictionary: {},

      showMilesNBonus: lib.getData('milesNBonusData'),
      milesNBonusLoggedIn: false,
      milesNBonusLogo: null,
    }
  },
  computed: {
    showBanner() {
      return !this.milesNBonusLoggedIn && this.showMilesNBonus
    },
    isDevice() {
      return lib.scrDevices()
    },
  },
  mounted() {
    if (lib.getData('milesNBonusData')) {
      const { configuration, dictionary, milesNBonusLogo } =
        lib.getData('milesNBonusData')
      this.milesNBonusLoggedIn = configuration.milesNBonusLoggedIn
      this.dictionary = dictionary
      this.milesNBonusLogo = milesNBonusLogo
    }
    this.setEventListeners()
  },
  methods: {
    logIn() {
      document.dispatchEvent(new CustomEvent('showMilesNBonusModal'))
    },
    setEventListeners() {
      document.addEventListener('milesNBonusLogStatus', (e) => {
        this.milesNBonusLoggedIn = e.detail.logStatus
      })
    },
  },
}
</script>
